(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-template"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    document.querySelectorAll('[data-r1]').forEach(block => {
      if (block.dataset.ready) return;
      block.dataset.ready = 'true';
      const form = block.closest('form');
      const toggle = block.querySelector('[data-r1-toggle]');
      const request = block.querySelector('[data-r1-request]');
      const fields = [...block.querySelectorAll('[data-r1-field]')];
      const error = block.querySelector('[data-r1-error]');
      let queue = Promise.resolve();
      let submitting = false;
      let saved = false;
      const sync = () => {
        request.value = toggle.checked ? 'Da' : 'Ne';
        block.querySelector('[data-r1-fields]').hidden = !toggle.checked;
        form.classList.toggle('sviben-r1-active', toggle.checked);
        fields.forEach(field => {
          field.required = toggle.checked;
          field.setCustomValidity('');
        });
      };
      const attributes = () => {
        const data = { 'R1 račun': request.value };
        fields.forEach(field => {
          const key = field.name.slice(11, -1);
          data[key] = toggle.checked ? field.value.trim() : '';
        });
        return data;
      };
      const save = () => {
        const data = attributes();
        queue = queue.catch(() => {}).then(async () => {
          const response = await fetch(block.dataset.updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: data })
          });
          if (!response.ok) throw new Error('Unable to save cart attributes');
        });
        return queue;
      };
      const validate = () => {
        if (!toggle.checked) return true;
        for (const field of fields) {
          field.value = field.value.trim();
          field.setCustomValidity(!field.value ? block.dataset.required :
            field.hasAttribute('data-r1-oib') && !/^[0-9]{11}$/.test(field.value) ? block.dataset.oibError : '');
          if (!field.reportValidity()) return false;
        }
        return true;
      };
      toggle.addEventListener('change', () => {
        sync();
        if (!toggle.checked) fields.forEach(field => { field.value = ''; });
        save().then(() => { error.hidden = true; }).catch(() => { error.hidden = false; });
      });
      fields.forEach(field => {
        field.addEventListener('input', () => { field.setCustomValidity(''); });
        field.addEventListener('change', () => {
          save().then(() => { error.hidden = true; }).catch(() => { error.hidden = false; });
        });
      });
      form.addEventListener('click', event => {
        if (event.target.closest('[name="checkout"]') && !validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      form.addEventListener('submit', async event => {
        if (event.submitter?.name !== 'checkout' || saved) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (submitting || !validate()) return;
        submitting = true;
        try {
          await save();
          error.hidden = true;
          saved = true;
          form.requestSubmit(event.submitter);
        } catch {
          error.hidden = false;
        } finally {
          submitting = false;
        }
      }, true);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
  } catch(e) { console.error(e); }
})();

})();
